<script lang="js" setup>
const props = defineProps({
  title: ''
})


</script>

<template>
<div class="container mx-auto pt-[2.5rem] md:pt-[2.5rem] lg:pt-[2.5rem] pb-1">
  <div class="flex flex-row justify-center items-center">
    <img src="https://cos5.51tgqj.com/techming/img/btzs1@2x.png" class="w-1/12"/>
    <text class="text-white text-3xl md:text-3xl lg:text-4xl">—{{props.title}}—</text>
    <img src="https://cos5.51tgqj.com/techming/img/btzs2@2x.png" class="w-1/12"/>
  </div>
</div>
</template>
<style scoped>
</style>
